import React from 'react';

const StackTheOdds: React.FC = () => {
  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-white pt-20 pb-20">
      <div className="">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content - Left Side */}
          <div className="space-y-6">
            <h2 className="text-[20px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#000] mb-7 lg:text-left text-center">
              Stack the Odds for Wealth
            </h2>
            <p className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0">
            Investing in junior mining stocks isn’t for everyone—but for those seeking outsized gains, it’s unparalleled. With The Wealthy Miner, you’re not gambling with the odds stacked against you; you’re leveraging  <strong>Robert's proven strategies</strong>  to identify the mining companies with the best odds of winning, avoid "snake eyes" projects, and target the next big win. Our <strong>real-time insights and interactive</strong> education save you time and boost your confidence, whether you’re a seasoned investor or new to the mining market.
            </p>
          </div>

          {/* Stock Chart Image - Right Side */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
                              <img 
                  src="/images/stack.webp" 
                  alt="Stock chart showing upward trend with green line and blue volume bars" 
                  className="w-full max-w-lg h-auto rounded-r-[25px]"
                />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StackTheOdds;
